import { CheckoutStep } from '@boels/models';

export const checkoutSteps: CheckoutStep[] = [
  {
    url: 'checkout/customer-details',
    urlParam: 'customer-details',
    localizedTitle: 'checkout.progress.details',
    step: 1,
  },
  {
    url: 'checkout/delivery-mode',
    urlParam: 'delivery-mode',
    localizedTitle: 'checkout.progress.deliveryMode',
    step: 2,
  },
  {
    url: '',
    urlParam: '',
    localizedTitle: 'checkout.progress.shippingAddress',
    step: 3,
  },
  {
    url: 'checkout/review-order',
    urlParam: 'review-order',
    localizedTitle: 'checkout.progress.reviewOrder',
    step: 4,
  },
];

export const deliveryCheckoutSteps: CheckoutStep[] = [
  {
    url: 'checkout/shipping-address',
    urlParam: 'shipping-address',
    localizedTitle: 'checkout.progress.delivery',
    step: 3,
  },
  {
    url: 'checkout/pickup',
    urlParam: 'pickup',
    localizedTitle: 'checkout.progress.pickup',
    step: 3,
  },
];
